<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> Danh sách hành động
        </span>
        <a-button slot="extra" type="primary" @click="showDrawerAdd">
          <a-icon type="plus" /> Thêm
        </a-button>
      </div>

      <a-drawer
        v-if="visibleAdd"
        title="Thêm"
        placement="right"
        :visible="visibleAdd"
        @close="closeDrawerAdd"
        :width="450"
      >
        <AddPermissionAction
          :createdOnView="createdOnView"
          :closeDrawerAdd="closeDrawerAdd"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleUpdate"
        title="Chỉnh sửa"
        placement="right"
        :visible="visibleUpdate"
        @close="closeDrawerUpdate"
        :width="450"
      >
        <UpdatePermissionAction
          :closeDrawerUpdate="closeDrawerUpdate"
          :itemId="itemId"
          :updateOnView="updateOnView"
          :deleteOnView="deleteOnView"
        />
      </a-drawer>

      <a-table
        :loading="loading"
        size="small"
        :columns="column"
        :data-source="list"
        rowKey="id"
        style="margin-top: 5px;"
      >
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>

        <div slot="createdAt" slot-scope="text, record">
          <p>
            {{ record.createdAt | formatDateHour }}
          </p>
        </div>

        <div slot="updatedAt" slot-scope="text, record">
          <p>
            {{ record.updatedAt | formatDateHour }}
          </p>
        </div>

        <div slot="action" slot-scope="text, record">
          <a-button
            icon="edit"
            @click="showDrawerUpdate(record)"
            class="icon-update"
          >
            Chỉnh sửa
          </a-button>
        </div>
      </a-table>
    </a-card>
  </div>
</template>
<script>
import AddPermissionAction from "./addPermissionAction";
import UpdatePermissionAction from "./updatePermissionAction";
import queryItem from "../data/queryItem";
import { column } from "../constants/dataColumn";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";

export default {
  components: {
    AddPermissionAction,
    UpdatePermissionAction,
  },
  data() {
    return {
      itemId: null,
      visibleAdd: false,
      visibleUpdate: false,
      loading: true,
      column,
      list: [],
    };
  },
  methods: {
    showDrawerAdd() {
      this.visibleAdd = true;
    },
    closeDrawerAdd() {
      this.visibleAdd = false;
    },
    showDrawerUpdate(record) {
      this.itemId = record.id;
      this.visibleUpdate = true;
    },
    closeDrawerUpdate() {
      this.visibleUpdate = false;
    },
    updateOnView(item) {
      this.list = updateForUpdated(this.list, item);
    },
    createdOnView(item) {
      this.list = updateForCreated({
        list: this.list,
        item,
      });
    },
    deleteOnView(item) {
      this.list = updateForDeleted(this.list, item);
    },

    getPermissionActions() {
      this.loading = true;
      this.$apollo
        .query({
          fetchPolicy: "no-cache",
          query: queryItem.queryGetAll,
        })
        .then(({ data }) => {
          if (data.getAllPermissionAction) {
            this.list = [...data.getAllPermissionAction];
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách vai", error);
        });
    },
  },
  created() {
    this.getPermissionActions();
  },
};
</script>
